module.exports = __webpack_public_path__ + "img/9788983782571.85aecfbd.jpg";